module.exports = __webpack_public_path__ + "img/knowledge-disabled.5a0f2f23.png";